import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 264 107",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "91",
      y: "48",
      width: "106",
      height: "12",
      rx: "6",
      fill: "var(--dt-color-foreground-critical)",
      id: "Rectangle 490"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M75 47.6552C71.4958 47.6552 68.6552 50.4958 68.6552 54C68.6552 57.5042 71.4958 60.3448 75 60.3448C78.5042 60.3448 81.3448 57.5042 81.3448 54C81.3448 50.4958 78.5042 47.6552 75 47.6552ZM67 54C67 49.5817 70.5817 46 75 46C79.4183 46 83 49.5817 83 54C83 58.4183 79.4183 62 75 62C70.5817 62 67 58.4183 67 54ZM75 50.3034C75.4571 50.3034 75.8276 50.674 75.8276 51.131V54C75.8276 54.4571 75.4571 54.8276 75 54.8276C74.5429 54.8276 74.1724 54.4571 74.1724 54V51.131C74.1724 50.674 74.5429 50.3034 75 50.3034ZM74.1724 56.869C74.1724 56.4119 74.5429 56.0414 75 56.0414H75.0072C75.4642 56.0414 75.8348 56.4119 75.8348 56.869C75.8348 57.326 75.4642 57.6966 75.0072 57.6966H75C74.5429 57.6966 74.1724 57.326 74.1724 56.869Z",
      fill: "var(--dt-color-foreground-critical)",
      id: "Vector (Stroke)"
    }, null, -1)
  ]))]))
}
export default { render: render }